// Module
var code = `<span on-click='MouseClick' 
      {{^.enabled}}disabled=""{{/}}    
      style="position: absolute; 
            {{#.width}}width:{{.width}}px;{{/}}
            {{#.height}}height:{{.height}}px;{{/}}
            {{#.top}}top:{{.top}}px;{{/}}
            {{#.left}}left:{{.left}}px;{{/}}
            {{^.visible}}display:none;{{/}}">
</span>`;
// Exports
export default code;